import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireClassnames } from "../node_modules/classnames/index.js";
var classnamesExports = requireClassnames();
const classnames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
export {
  classnames as default
};
//# sourceMappingURL=index.js.map
